/**
 * SEC-010 FIX: Logger utility that only logs in development mode
 * Prevents PII and debug info from leaking to production browser consoles
 */

const isDev = process.env.NODE_ENV === 'development';

export const logger = {
  /**
   * Debug logging - only in development
   */
  debug: (...args: unknown[]) => {
    if (isDev) {
      console.log(...args);
    }
  },

  /**
   * Info logging - only in development
   */
  info: (...args: unknown[]) => {
    if (isDev) {
      console.info(...args);
    }
  },

  /**
   * Warning logging - always enabled
   */
  warn: (...args: unknown[]) => {
    console.warn(...args);
  },

  /**
   * Error logging - always enabled
   */
  error: (...args: unknown[]) => {
    console.error(...args);
  },
};

export default logger;
